exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".currency-sign[data-v-9d23f6c4]{top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);left:20px;line-height:1;margin-top:1px}.base-input-number__input[data-v-9d23f6c4]{border-style:solid;border-width:0 0 1px 0;width:50px;height:1.4rem;line-height:1.7rem}@media only screen and (min-width: 1025px){.base-input-number__input[data-v-9d23f6c4]{height:1.7rem}}.base-input-number__label[data-v-9d23f6c4]{font-size:0.8rem;line-height:1.2rem}@media only screen and (min-width: 1025px){.base-input-number__label[data-v-9d23f6c4]{font-size:1rem;line-height:1.4rem}}\n", ""]);

// exports
